import React, { useRef } from 'react';
import { VideoIcon } from '@fiverr-private/icons';
import { Center, Wrap } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { theme } from '@fiverr-private/theme';
import { translate } from '@fiverr-private/i18n-react';
import { useEnteredView } from '@fiverr-private/hooks';
import { consultationIndicationView } from '../../utils/events';
import { BiEnrichment } from '../Consultation/types';

export interface ConsultationIndicationProps {
  wrapperProps?: Partial<React.ComponentProps<typeof Wrap>>;
  iconSize?: React.ComponentProps<typeof VideoIcon>['size'];
  iconColor?: React.ComponentProps<typeof VideoIcon>['color'];
  textColor?: React.ComponentProps<typeof Typography>['color'];
  sellerId: number;
  sellerName?: string;
  biEnrichment: BiEnrichment;
}

export const ConsultationIndication: React.FC<ConsultationIndicationProps> = ({
  wrapperProps = {},
  iconSize,
  iconColor = theme.colors.grey_1100,
  textColor = 'grey_1100',
  sellerId,
  sellerName,
  biEnrichment,
}) => {
  const observableRef = useRef(null);

  const consultationCopy = sellerName
    ? translate('consultation.consultation_indication', { params: { sellerName } })
    : translate('consultation.offers_paid_consultations');

  useEnteredView(observableRef, {
    threshold: 1,
    onEntered: () => {
      consultationIndicationView(biEnrichment, sellerId);
    },
  });

  return (
    <Wrap gap="2" alignItems="center" {...wrapperProps} ref={observableRef} width="100%">
      <Center>
        <VideoIcon size={iconSize} color={iconColor} />
      </Center>
      <Typography size="b_sm" fontWeight="semibold" color={textColor} as="span">
        {consultationCopy}
      </Typography>
    </Wrap>
  );
};
